import { memo, useEffect, useRef } from "react"
import { Stack, Text, Center, Button, Container, Box, Input, VStack, Card } from "@chakra-ui/react"
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"
import { useApp } from "contexts/app"
import { useForm } from "react-hook-form"
import { Field } from "@/components/ui/field"
import { useNavigate } from "react-router"
import { useAuth } from "contexts/auth"
import _ from "lodash"

const GuestCheckout = () => {
    const { setProcessing, setPageTitle, showToast } = useApp();
    const { showLogin } = useAuth();
    const { cart, updateShippingAddress, completeCart, create } = useCart();
    const formRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        setPageTitle("Thanh toán")
    }, [setPageTitle])

    const { register, handleSubmit, formState: { errors }, setValue } = useForm();

    const fillCustomerForm = (customer) => {
        if (!customer) return;
        setValue("phone_number", customer?.phone || customer?.phone_number || "");
        setValue("full_name", customer?.full_name || "");
        setValue("address", customer?.address || "");
    };

    useEffect(() => {
        if (!_.isEmpty(cart?.shipping_address)) {
            fillCustomerForm(cart.shipping_address);
        }
    }, [cart?.id]);

    const onCartComplete = async (data) => {
        setProcessing(true);
        await updateShippingAddress(data);
        try {
            var order = await completeCart();
            await create();
            setProcessing(false);
            showToast({ description: "Vui lòng thanh toán để hoàn tất đơn hàng", type: "success" });
            navigate(`/order-pay/${order.id}`);
        } catch (error) {
            if (error.error_code === "voucher_not_allow") {
                showToast({
                    description: "Không thể áp dụng mã khuyến mãi. Vui lòng xoá mã khuyến mãi để tiếp tục",
                    type: "error",
                    duration: 6000,
                });
                navigate("/cart");
            }
            setProcessing(false);
        }
    };

    const onSubmit = handleSubmit(async (data) => {
        var loggedInUser = await showLogin({ phone: data.phone_number, customer_info: data });
        if (!loggedInUser) return;
        fillCustomerForm(loggedInUser);
        setTimeout(() => onCartComplete(data), 500);
    });

    const onExistingAccountLogin = async () => {
        var customerLogin = await showLogin({});
        if (!customerLogin) return;
        fillCustomerForm(customerLogin);
        await updateShippingAddress({
            phone_number: customerLogin?.phone || customerLogin?.phone_number,
            full_name: customerLogin?.full_name,
            address: customerLogin?.address,
        });
        navigate("/checkout", { replace: true });
    };

    return (
        <div style={{ paddingBottom: 75 }}>
            <form ref={formRef} onSubmit={onSubmit}>
                <Stack gap="4" align="flex-start" maxW="sm">
                    <Text>Thông tin khách hàng</Text>

                    <Field label="Số điện thoại" invalid={!!errors.phone_number} errorText={errors.phone_number?.message}>
                        <Input {...register("phone_number", { required: "Bạn phải nhập số điện thoại" })} />
                    </Field>
                    <Field label="Họ và tên" invalid={!!errors.full_name} errorText={errors.full_name?.message}>
                        <Input {...register("full_name", { required: "Bạn phải nhập họ và tên" })} />
                    </Field>
                    <Field label="Địa chỉ" invalid={!!errors.address} errorText={errors.address?.message}>
                        <Input {...register("address", { required: "Bạn phải nhập địa chỉ" })} />
                    </Field>
                    <Field label="Ghi chú">
                        <Input {...register("note")} placeholder="Ghi chú thêm cho đơn hàng" />
                    </Field>

                    <VStack style={{ width: "100%" }}>
                        <Button type="button" variant="outline" onClick={onExistingAccountLogin}>
                            Đăng nhập nếu bạn đã có tài khoản
                        </Button>
                    </VStack>
                </Stack>
            </form>

            <div style={{ position: "fixed", bottom: 0, left: 0, padding: 0, width: "100vw" }}>
                <Container maxW="md" style={{ padding: 0 }}>
                    <Box bg="bg" shadow="md">
                        <div style={{ display: "flex", padding: 16 }}>
                            <div style={{ flexGrow: 1 }}>
                                <Center height="100%">
                                    <Text fontWeight="semibold">{formatCurrency(cart?.total_amount)}</Text>
                                </Center>
                            </div>
                            <div>
                                <Button onClick={() => handleSubmit(onSubmit)()}>Hoàn tất</Button>
                            </div>
                        </div>
                    </Box>
                </Container>
            </div>
        </div>
    );
};

export default memo(GuestCheckout);
